const info = {
    CN: {
        //中文翻译
        banner: {
            slogan: "",
            title1: "SiGReal Tech",
            title2: "从风险创造价值",
            title3: "SiGReal Empowers AI to Transform Risk into Return",
            title4: "",
            // title:"人工智能赋能者",
            // content:"释放人工智能价值，赋能保险公司、汽车主机厂等创新保障业务场景，助力产业升级"
        },
        aboutUs: {
            title: "公司简介",
            content1:
                "宏瓴科技以“AI大模型”为核心自主研发的全栈式风险评估系统，利用Transformer+自监督预训练技术、强化学习微调技术及图神经网络数据挖掘技术等技术实现跨场景的风险模型训练、迁移和场景化微调，通过端到端的技术解决方案加精细化的运营手段，为保险、物流、配送、主机厂、营运出行平台和电商等行业提供行业领先的数字化运营管控和风险减量（识别、预测、量化）平台，已在实际业务场景中实现产品化落地并发挥重要作用。通过平台引导传统作业流程升级并提高人效，真正实现从源头降低风险。",
            content2:
                "核心团队来自清华大学、南开大学、中科院、波士顿大学等国内外知名院校，曾就职世界500强头部科技公司的核心研发和管理岗位，拥有丰富的 人工智能算法、交通运输物流 、智慧农业及电商等复合产业经验，实现“数据-算法-业务场景应用”闭环，确保模型效果持续领跑行业。",
            content3:
                "宏瓴科技获得国内头部资本认可及多轮投资包括亦庄国投、上汽资本、苏州市创投等。",
        },
        ourCulture: {
            title: "企业文化",
            cultureTitle: [
                "成就客户",
                "务实落地",
                "正直担当",
                "延迟满足感",
                "强执行力",
                "乐观进取",
            ],
        },
        service: {
            title: "我们的服务",
            list: [
                {
                    title: "AI+物流配送平台",
                    txt1: "新兴行业安全保障服务",
                },
                {
                    title: "AI+出行/商用车平台",
                    txt1: "营运车队风险管控服务",
                },
                {
                    title: "AI+主机厂",
                    txt1: "基于多模态大模型的车联网服务",
                },
                {
                    title: "AI+农险+测绘",
                    txt1: "安农保AI智能农险服务",
                },
            ],
        },
        quote: {
            title: "Reinvent Risk Control with",
            subTitle: " Advanced AI",
            sign1: "",
            sign2: "",
        },
    },
    EN: {
        //英文翻译
        banner: {
            slogan: "",
            title1: "SiGReal Tech",
            title2: "",
            title3: "SiGReal Empowers AI to Transform Risk into Return",
            title4: "",
            // title:"Artificial Intelligence Enablers",
            // content:""
        },
        aboutUs: {
            title: "About Us",
            content1:
                'SiGREAL Tech has independently developed a full-stack risk assessment system with "AI large models" at its core. Leveraging cutting-edge technologies such as transformer+self-supervised pre-training, reinforcement learning fine-tuning, and graph neural network data mining, the system achieves cross-scenario training, transfer, and contextual fine-tuning for risk models. Through integrated end-to-end tech solutions and refined operational tactics, it delivers industry-leading digital operation management and risk mitigation (identification, prediction, quantification) platforms for insurance, logistics, distribution, automotive OEMs, mobility platforms and SMEs. These solutions have been successfully commercialized in real-world business scenarios, driving the upgrading of traditional workflows, enhancing operational efficiency, and achieving genuine risk reduction at the source.',
            content2:
                'The core team consists of professionals from prestigious institutions worldwide, including Tsinghua University, Nankai University, Chinese Academy of Sciences, and Boston University. With prior experience in key R&D and management roles at Fortune Global 500 tech giants, they possess extensive interdisciplinary expertise spanning AI algorithms, transportation & logistics, smart agriculture, and SMEs. This enables the seamless closure of the "data-algorithm-business application" loop, ensuring sustained industry leadership in model performance.',
            content3:
                "SiGREAL Tech has secured multiple rounds of investment from leading domestic capital institutions, including Beijing E-Town Capital, SAIC Capital, and Suzhou Venture Capital, underscoring wide recognition of its technical strength and growth potential.",
        },
        ourCulture: {
            title: "Our Culture",
            cultureTitle: [
                "Pursue Customer Success",
                "Down-to-Earth",
                "Integrity",
                "Delayed Gratification",
                "Execution",
                "Proactivity",
            ],
            cultureIntro: ["", "", "", "", "", ""],
        },
        service: {
            title: "Services",
            list: [
                {
                    title: "Al+Logistics/DeliveryPlatforms",
                    txt1: "Logistics/Delivery Industry Safety and Security Services",
                },
                {
                    title: "Al+Mobility/CommercialVehicle Platforms",
                    txt1: "Fleet Risk Control",
                },
                {
                    title: "Al+Automotive OEM",
                    txt1: "Multimodal Large Model-Based IoV Services",
                },
                {
                    title: "AI+Agricultural Insurance+Mapping",
                    txt1: "AnNongBao Intelligent Agri-Insurance Service",
                },
            ],
        },
        quote: {
            title: "Reinvent Risk Control with",
            subTitle: " Advanced AI",
            sign1: "",
            sign2: "",
        },
    },
};
export default info; //需要暴露出去
